import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mr-3 embedding-summary-avatar" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "d-flex flex-wrap align-center flex-grow-1" }
const _hoisted_6 = {
  key: 0,
  class: "card-action-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_IconToggle = _resolveComponent("IconToggle")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "ma-0 pa-2 card bg-background",
    color: "background",
    variant: "elevated",
    elevation: _ctx.isOverlay ? 0 : 4,
    density: "compact"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        class: "ma-0 pa-0",
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
        density: "compact"
      }, {
        default: _withCtx(() => [
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_item, {
                key: 0,
                class: "embedding-summary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleShow(true)))
              }, {
                prepend: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_ctx.showStandaloneIcon && _ctx.iconMode !== 'mono')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: (_ctx.icon as ProviderIcon).src,
                          alt: `${_ctx.providerKey || 'embedding'} icon`,
                          class: "embedding-summary-avatar-image",
                          onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onIconError && _ctx.onIconError(...args)))
                        }, null, 40, _hoisted_2))
                      : (_ctx.showStandaloneIcon)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "embedding-summary-avatar-mask",
                            style: _normalizeStyle(_ctx.iconMaskStyle),
                            role: "img",
                            "aria-label": `${_ctx.providerKey || 'embedding'} icon`
                          }, null, 12, _hoisted_3))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: "embedding-summary-initials",
                            style: _normalizeStyle({ backgroundColor: _ctx.brandColor })
                          }, _toDisplayString(_ctx.embeddingInitials), 5))
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-truncate" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.name || 'Embedding Model'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_subtitle, { class: "text-truncate" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.providerKey || 'No provider') + " · " + _toDisplayString(_ctx.modelName || 'No API model selected'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 1,
                class: "pt-0 pb-0 embedding-summary-text"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_chip, {
                        size: "small",
                        variant: "tonal",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.collectionUsageLabel), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    (!_ctx.isOverlay)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          color: "primary",
                          icon: "mdi-chevron-down",
                          size: "large",
                          variant: "plain",
                          class: "embedding-summary-expand",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleShow(true)), ["stop"]))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_v_list, {
                class: "ma-0 pa-0 bg-background",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    class: "ma-0 pa-0",
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.providerKey,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.providerKey) = $event)),
                          _ctx.providerChanged
                        ],
                        items: _ctx.providerKeys,
                        label: "Provider",
                        class: "pt-2",
                        variant: "outlined",
                        density: "compact",
                        rules: [() => !!_ctx.providerKey || 'Provider is required']
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, {
                    class: "ma-0 pa-0",
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_autocomplete, {
                        modelValue: _ctx.modelName,
                        "onUpdate:modelValue": [
                          _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelName) = $event)),
                          _ctx.modelSelected
                        ],
                        items: _ctx.models,
                        "item-title": "id",
                        "item-value": "id",
                        label: "Provider Models",
                        class: "pt-2",
                        variant: "outlined",
                        density: "compact",
                        disabled: !_ctx.providerKey,
                        loading: _ctx.modelsLoading,
                        readonly: _ctx.modelsLoading,
                        rules: [() => !!_ctx.modelName || 'Provider model is required']
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_Button, {
                            color: "primary",
                            buttonClass: "ml-n2",
                            click: _ctx.syncModels,
                            disabled: _ctx.syncDisabled,
                            icon: "mdi-sync",
                            size: "x-large",
                            tooltip: "Sync Models"
                          }, null, 8, ["click", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled", "loading", "readonly", "rules"])
                    ]),
                    _: 1
                  }),
                  (_ctx.showAdvanced)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        class: "ma-0 pa-0",
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.name,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.name) = $event)),
                            onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.trackFieldUpdate('name'))),
                            label: "Model Name",
                            class: "pt-2",
                            rules: [() => !!_ctx.name || 'Model Name is required'],
                            variant: "outlined",
                            density: "compact",
                            clearable: ""
                          }, {
                            "append-inner": _withCtx(() => [
                              (_ctx.name == null || _ctx.name == '')
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    text: "Autofill from selected API model"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_icon, _mergeProps(props, {
                                        color: "primary",
                                        icon: "mdi-lightning-bolt-outline",
                                        onClick: _ctx.autofillName
                                      }), null, 16, ["onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.show]
              ])
            ]),
            _: 1
          }),
          (_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_actions, {
                key: 2,
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    color: "primary",
                    class: "mr-4",
                    disabled: _ctx.saveDisabled,
                    click: _ctx.updateModel,
                    icon: "mdi-check-bold",
                    size: "x-large",
                    tooltip: "Save Model",
                    density: "compact"
                  }, null, 8, ["disabled", "click"]),
                  _createVNode(_component_Button, {
                    color: "warning",
                    class: "mr-4",
                    disabled: _ctx.isSystemModel,
                    click: _ctx.initiateDeleteModel,
                    icon: "mdi-trash-can-outline",
                    size: "x-large",
                    tooltip: "Delete Model",
                    density: "compact"
                  }, null, 8, ["disabled", "click"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_IconToggle, {
                    value: _ctx.showAdvanced,
                    onValue: _ctx.toggleAdvanced,
                    tooltip: "Toggle advanced options"
                  }, null, 8, ["value", "onValue"]),
                  (!_ctx.isOverlay)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        color: "primary",
                        class: "mx-auto",
                        icon: "mdi-chevron-up",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleShow(false))),
                        density: "compact"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.waiting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.actionMessage), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_ConfirmationDialog, {
        modelValue: _ctx.showDeleteConfirmationDialog,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showDeleteConfirmationDialog) = $event)),
        title: "Confirm Embedding Model Deletion",
        message: "Are you sure you want to delete this embedding model configuration?",
        itemName: _ctx.modelNameToDelete,
        itemType: "embedding model",
        loading: _ctx.waiting,
        warningMessage: _ctx.additionalWarningMessage,
        onConfirm: _ctx.confirmModelDelete,
        onCancel: _ctx.cancelDeleteModel
      }, null, 8, ["modelValue", "itemName", "loading", "warningMessage", "onConfirm", "onCancel"])
    ]),
    _: 1
  }, 8, ["elevation"]))
}